/* eslint-disable @typescript-eslint/ban-ts-ignore */
/** Check if the browser is Firefox and whether that particular version supports screensharing */
export default function isFirefox () {

  // @ts-ignore
  const mediaSourceSupport = !!navigator.mediaDevices.getSupportedConstraints().mediaSource
  const matchData = navigator.userAgent.match(/Firefox\/(\d*)\.?/)
  let firefoxVersion = 0

  if (matchData && matchData[1]) {

    firefoxVersion = parseInt(matchData[1], 10)

  }

  return mediaSourceSupport && firefoxVersion >= 52

}
